import React, { useState } from "react";

interface CustomInputProps {
  id: string;
  className?: string;
  placeholder?: string;
  value: string | number;
  type?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  pattern?: string;
  required?: boolean;
  maxLength?: number;
  errorMessage?: string;
  label?: string;
}

const CustomInput: React.FC<CustomInputProps> = ({
  id,
  className,
  placeholder,
  value,
  type,
  onChange,
  pattern,
  required = false,
  maxLength,
  errorMessage,
  label,
}) => {

  const [error, setError] = useState<string>("");
  const [touched, setTouched] = useState<boolean>(false);

  const validateInput = (inputValue: string) => {
    // Check if required field is empty
    if (required && !inputValue.trim()) {
      return `${label || "This field"} is required`;
    }

    // Check pattern validation
    if (pattern && inputValue) {
      const regex = new RegExp(pattern);
      if (!regex.test(inputValue)) {
        return errorMessage || "Invalid format";
      }
    }

    return "";
  };

  const handleBlur = () => {
    setTouched(true);
    const validationError = validateInput(String(value));
    setError(validationError);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;


    // For number inputs with maxLength, prevent entry beyond maxLength
    if (maxLength && inputValue.length > maxLength) {
      return;
    }

    onChange(e);

    // Clear error when user starts typing
    if (touched && error) {
      const validationError = validateInput(inputValue);
      setError(validationError);
    }
  };

  return (
    <div>
      <input
        id={id}
        type={type}
        className={`form-control ${className || ""} ${touched && error ? "is-invalid" : ""}`}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        pattern={pattern}
        required={required}
        maxLength={maxLength}
      />
      {
        touched && error && (
          <div className="invalid-feedback d-block">{error}</div>
        )
      }
    </div>

  );
};

export default CustomInput;